import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NavButtonComponent } from './components/nav-button/nav-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MENU_NAV_ITEMS } from './config/constants';
import { PlannerViewsStateService } from '../planner/services/planner-views-state.service';
import { CUSTOM_ROUTE_MOBILE_MAP } from '../../components/custom-route-mobile/config/constants';
import { CustomRouteMobileViewsStateService } from '../../components/custom-route-mobile/services/custom-route-mobile-views-state.service';
import { SessionStorageService } from 'src/app/services/session-storage.service';
import { ChatBotScriptService, ScrollService } from 'src/app/services';
import { EditRouteService } from '../planner/components/edit-route/services';

@Component({
  selector: 'app-menu-nav',
  standalone: true,
  imports: [
    NavButtonComponent, 
    TranslateModule
  ],
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuNavComponent {
  private _plannerViewsStateService = inject(PlannerViewsStateService);
  private _sessionStorageService = inject(SessionStorageService);
  private _customRouteMobileViewsStateService = inject(CustomRouteMobileViewsStateService);
  private _scrollService = inject(ScrollService);
  private _chatbotScriptService = inject(ChatBotScriptService);
  private _editRouteService = inject(EditRouteService);

  private isLoadingResourcesByIdOnEmptySpace = computed(() => this._editRouteService.isLoadingResourcesByIdOnEmptySpace());
  private isLoadingResourcesOnExistingItem = computed(() => this._editRouteService.isLoadingResourcesOnExistingItem());
  public checkIfLoadingNewResources = computed(() => this.isLoadingResourcesByIdOnEmptySpace() !== null || this.isLoadingResourcesOnExistingItem());
    
  protected mobileViewsState = this._customRouteMobileViewsStateService.mobileViewsState;
  protected chatId = this._chatbotScriptService.chatId;
  
  
  public  navItems = MENU_NAV_ITEMS;

  public handleNavItemClick(item: { iconName: string; label: string; value: string }): void {
    if (this.checkIsDisabled(item)) return; 
    
    switch (item.value) {
      case CUSTOM_ROUTE_MOBILE_MAP.planner:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.planner);
        break;
      case CUSTOM_ROUTE_MOBILE_MAP.map:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.map);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.map);
        break;
      case CUSTOM_ROUTE_MOBILE_MAP.chatbot:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.chatbot);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.chatbot);
        break;
      case CUSTOM_ROUTE_MOBILE_MAP.more:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.more);
        this._customRouteMobileViewsStateService.mobileViewsState.set(CUSTOM_ROUTE_MOBILE_MAP.more);
        break;
      default:
        this._sessionStorageService.setItem('customRouteMobileViewsState', CUSTOM_ROUTE_MOBILE_MAP.planner);
        this._customRouteMobileViewsStateService.setMobileViewsState(CUSTOM_ROUTE_MOBILE_MAP.planner);
        break;
    }
    
    // Close the edit route view if it's open
    // The default view of the planner is the route-timeline view
    this._plannerViewsStateService.isEditRouteView.set(false);
    this._plannerViewsStateService.isBuyTicketsView.set(false);
    
    // Reset scroll state
    this._scrollService.setIsScrolled(false);
  }
  
  protected checkIsDisabled(item: { iconName: string; label: string; value: string }): boolean {
    if (item.iconName === CUSTOM_ROUTE_MOBILE_MAP.chatbot) {
      const chatId = this.chatId();
      return !chatId || chatId.length === 0;
    }
    return false;
  }
}
